
import * as React from 'react'
import isBrowser from '../../../services/isBrowser'

import { useAppSelector } from '../../../hooks/useAppSelector'
import { useRef, useState } from 'react';
import L, { } from 'leaflet';
import _ from 'lodash';
import { useMapInit } from '../../../hooks/map/useMapInit';
import { useAppDispatch } from '../../../hooks/useAppDispatch';
import { useZoomToContinent } from '../../../hooks/map/useZoomToContinent';
import { useMapMarkers } from '../../../hooks/map/useMapMarkers';

export type MarkerInfo = { image?: L.Marker, marker?: L.CircleMarker, circles?: L.Circle[], generatedByInteraction?: boolean }

export const AppMap = ({ fromMainSearchForm, delayedRenderId, className }: { fromMainSearchForm: boolean, delayedRenderId?: string, className?: string }) => {

    const isExtended = useAppSelector(state => {
        return state.weatherSearch.extendedSearch;
    });

    const currentMarkers = useRef<{ [key: string]: MarkerInfo }>({});
    const mapRef = useRef<L.Map>();
    const idRef = useRef<string>(`map-${Math.random().toString(16)}`);


    const [browser, setBrowser] = useState<boolean>(false);
    const [mapInitialized, setMapInitialized] = useState<boolean>(false);

    useMapInit({ browser, delayedRenderId, fromMainSearchForm, idRef, mapRef, setMapInitialized });
    useZoomToContinent({ mapRef, fromMainSearchForm });
    useMapMarkers({ mapRef, currentMarkers, fromMainSearchForm, isExtended, mapInitialized });


    React.useEffect(() => {
        if (isBrowser()) {
            setBrowser(true);
        }

    }, [])


    return (
        browser ?
            <div id={idRef.current}
                className={`w-full h-full ${className}`}>
            </div> : <div className={`w-full h-full ${className}`} />
    )
}
